import React, { useState } from "react";
import { images } from "../../constants";
import { AppWrap, MotionWrap } from "../../wrapper";
import { client } from "../../client";
import "./Footer.scss";

const Footer = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [focusedInput, setFocusedInput] = useState("");

  const { name, email, message } = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const handleFocus = (inputName) => {
    setFocusedInput(inputName);
  };

  const handleBlur = () => {
    setFocusedInput("");
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = () => {
    let formErrors = {};

    if (!name.trim()) {
      formErrors.name = "Name is required.";
    }

    if (!email.trim()) {
      formErrors.email = "Email is required.";
    } else if (!validateEmail(email)) {
      formErrors.email = "Please enter a valid email address.";
    }

    if (!message.trim()) {
      formErrors.message = "Message is required.";
    }

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    setLoading(true);

    const contact = {
      _type: "contact",
      name,
      email,
      message,
    };

    client.create(contact).then(() => {
      setLoading(false);
      setIsFormSubmitted(true);
    });
  };

  return (
    <>
      <h2 className="head-text">Get in touch with me</h2>

      <div className="app__footer-cards">
        <div className="app__footer-card">
          <img src={images.mail} alt="mail" />
          <a target="_blank" rel="noreferrer">
            djordje.vasilevski95@gmail.com
          </a>
        </div>
        <div className="app__footer-card">
          <img src={images.mobile} alt="mobile" />
          <a href="tel: +381 638801132" className="p-text">
            +381 638801132
          </a>
        </div>
      </div>

      {!isFormSubmitted ? (
        <div className="app__footer-form app__flex">
          <div className="app__flex">
            <input
              className={`p-text ${focusedInput === "name" ? "focused" : ""}`}
              type="text"
              placeholder="Your Name"
              name="name"
              value={name}
              onChange={handleChangeInput}
              onFocus={() => handleFocus("name")}
              onBlur={handleBlur}
            />
          </div>
          {errors.name && <p className="error-text">{errors.name}</p>}

          <div className="app__flex">
            <input
              className={`p-text ${focusedInput === "email" ? "focused" : ""}`}
              type="email"
              placeholder="Your Email"
              name="email"
              value={email}
              onChange={handleChangeInput}
              onFocus={() => handleFocus("email")}
              onBlur={handleBlur}
            />
          </div>
          {errors.email && <p className="error-text">{errors.email}</p>}

          <div>
            <textarea
              className={`p-text ${
                focusedInput === "message" ? "focused" : ""
              }`}
              placeholder="Your Message"
              value={message}
              name="message"
              onChange={handleChangeInput}
              onFocus={() => handleFocus("message")}
              onBlur={handleBlur}
            />
          </div>
          {errors.message && <p className="error-text">{errors.message}</p>}

          <button type="button" className="p-text" onClick={handleSubmit}>
            {loading ? "Sending" : "Send Message"}
          </button>
        </div>
      ) : (
        <div>
          <h3 className="head-text">Thank you for reaching out to me!</h3>
        </div>
      )}
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, "app__footer"),
  "contact",
  "app__whitebg"
);
